import { useCallback } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { UpdateUserPayload, UserResponse } from '../entities';
import {
  fetchUserInformation,
  updateUser,
  updateUserPreferences,
  updateUserResponses,
} from '../store/actions';
import { getUserInformation, getUserResponses } from '../store/selectors';

export function useUser() {
  const dispatch = useDispatch();

  const userResponses = useSelector(getUserResponses);
  const userPreferences = useSelector(getUserInformation);

  const doUpdateUserPreferences = useCallback(
    (data: Record<string, unknown>) => {
      dispatch(updateUserPreferences(data));
    },
    [dispatch],
  );

  const doUpdateUser = useCallback(
    (data: UpdateUserPayload) => {
      dispatch(updateUser(data));
    },
    [dispatch],
  );

  const doUpdateUserResponses = useCallback(
    (data: Record<string, UserResponse>) => {
      dispatch(updateUserResponses(data));
    },
    [dispatch],
  );

  const doFetchUserInformation = useCallback(async () => {
    await dispatch(fetchUserInformation());
  }, [dispatch]);

  return {
    updateUserResponses: doUpdateUserResponses,
    updateUserPreferences: doUpdateUserPreferences,
    fetchUserInformation: doFetchUserInformation,
    updateUser: doUpdateUser,
    userResponses,
    userPreferences,
  };
}
